import styled from 'styled-components';

/* The flow's dark full-bleed chrome, shared by step 0 and the loading screen.

   It lives here rather than in step 0's styles because the loading screen has to
   look the same: it used to render inside the light General layout with the
   marketing nav, so reloading mid-flow flashed what looked like a different
   product before the dark step appeared. */
/* The flow screen covers the app chrome, so anything that has to appear over it —
   the video modal — must layer from here rather than from a library default.
   antd's modal sits at 1000, which is below this. */
export const FLOW_SCREEN_Z_INDEX = 2000;

export const Overlay = styled.section`
  position: fixed;
  inset: 0;
  z-index: ${FLOW_SCREEN_Z_INDEX};
  /* Clipped on the x axis. Bloom bleeds 160px past the left edge and is 720px
     wide, so its right edge lands at 560px: on a 390px phone that turned the
     whole flow into a horizontal pan, with the card shifted off screen and bare
     background beside it. The overflow-x guard on html/body in styles/global.ts
     cannot reach it, because this overlay is fixed and owns its own scrollport. */
  overflow: hidden auto;
  display: flex;
  flex-direction: column;
  background-color: #13131f;
  padding: 32px 16px;
  font-family: 'Inter', sans-serif;

  @media (min-width: 640px) {
    padding: 32px 24px;
  }
`;

export const Bloom = styled.div`
  pointer-events: none;
  position: absolute;
  bottom: -160px;
  left: -160px;
  width: 720px;
  height: 720px;
  border-radius: 9999px;
  background: radial-gradient(
    closest-side,
    rgba(82, 98, 170, 0.35),
    transparent 72%
  );
`;

export const Logo = styled.img`
  position: relative;
  z-index: 10;
  height: 24px;
  width: auto;
  align-self: flex-start;
`;
